import {
  NOTIFICATION_DROPDOWN_REFRESH,
  NOTIFICATION_DROPDOWN_REFRESH_SUCCESS,
  NOTIFICATION_DROPDOWN_REFRESH_ERROR,
} from "./actionTypes"

const initialState = {
  count: 0,
  notifications: [],
  loading: false,
  error: "",
}

const NotificationDropdown = (state = initialState, action) => {
  switch (action.type) {
    case NOTIFICATION_DROPDOWN_REFRESH:
      state = {
        ...state,
        loading: true,
        error: "",
      }
      break
    case NOTIFICATION_DROPDOWN_REFRESH_SUCCESS:
      state = {
        ...state,
        loading: false,
        count: action.payload.data.response.count,
        notifications: action.payload.data.response.notifications,
      }
      break
    case NOTIFICATION_DROPDOWN_REFRESH_ERROR:
      state = {
        ...state,
        loading: false,
        error: action.payload
      }
      break
    default:
      state = {...state}
      break
  }
  return state
}
export default NotificationDropdown
